// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import {
  ActivityIcon,
  ArrowRightIcon,
  CalendarIcon,
  CircleAlertIcon,
  CircleCheckBigIcon,
  ClockIcon,
  Link,
  LogOutIcon,
  MailIcon,
  MapPinIcon,
  Navigate,
  PhoneIcon,
  React,
  SaveIcon,
  ShieldIcon,
  ShoppingBagIcon,
  SquarePenIcon,
  UserIcon,
  XIcon,
  jsxRuntime,
  motion,
} from "../vendor/runtime.js";
import { api } from "../api/client.js";
import { Navbar } from "../components/Navbar.jsx";
const ProfilePage = () => {
  var X, se;
  const { currentUser: a, loading: n, logout: i } = useAuth(),
    [l, c] = React.useState(false),
    [u, m] = React.useState(0),
    [f, x] = React.useState(true),
    [p, g] = React.useState(null),
    [b, y] = React.useState(false),
    [w, N] = React.useState(false),
    [T, C] = React.useState(""),
    [A, O] = React.useState(""),
    [M, Y] = React.useState(false),
    [R, U] = React.useState("");
  (React.useEffect(() => {
    a && (g(a), C(a.phone || ""), O(a.address || ""));
  }, [a]),
    React.useEffect(() => {
      a &&
        (async () => {
          try {
            x(true);
            const k = await api.get("/purchases/");
            m(k.data.length || 0);
          } catch (k) {
            console.error("Failed to fetch purchases", k);
          } finally {
            x(false);
          }
        })();
    }, [a]));
  const W = async () => {
      try {
        Y(true);
        const re = await api.patch("/auth/user/contact", {
          phone: T,
        });
        (re.data.success || re.status === 200) &&
          (U("Phone number updated successfully!"),
          y(false),
          g((k) => ({
            ...k,
            phone: T,
          })),
          setTimeout(() => U(""), 3e3));
      } catch (re) {
        (console.error("Failed to update phone:", re),
          U("Failed to update phone number. Please try again."),
          setTimeout(() => U(""), 3e3));
      } finally {
        Y(false);
      }
    },
    B = async () => {
      try {
        Y(true);
        const re = await api.patch("/auth/user/contact", {
          address: A,
        });
        (re.data.success || re.status === 200) &&
          (U("Address updated successfully!"),
          N(false),
          g((k) => ({
            ...k,
            address: A,
          })),
          setTimeout(() => U(""), 3e3));
      } catch (re) {
        (console.error("Failed to update address:", re),
          U("Failed to update address. Please try again."),
          setTimeout(() => U(""), 3e3));
      } finally {
        Y(false);
      }
    },
    G = () => {
      (C((p == null ? undefined : p.phone) || ""), y(false));
    },
    te = () => {
      (O((p == null ? undefined : p.address) || ""), N(false));
    },
    ne = p || a,
    de = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
          ease: [0.22, 1, 0.36, 1],
        },
      },
    },
    Me = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.08,
        },
      },
    },
    Ce = {
      hidden: {
        opacity: 0,
        scale: 0.95,
      },
      visible: {
        opacity: 1,
        scale: 1,
        transition: {
          type: "spring",
          stiffness: 300,
          damping: 25,
        },
      },
    };
  if (n)
    return (
      <div
        className={
          "min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex flex-col justify-center items-center px-4"
        }
      >
        <motion.div
          initial={{
            scale: 0.8,
            opacity: 0,
          }}
          animate={{
            scale: 1,
            opacity: 1,
          }}
          className={"relative w-16 h-16 sm:w-20 sm:h-20 mb-4 sm:mb-6"}
        >
          <div className={"absolute inset-0 border-4 border-indigo-100 rounded-full"} />
          <div
            className={
              "absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"
            }
          />
        </motion.div>
        <motion.p
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            delay: 0.2,
          }}
          className={"text-slate-600 font-medium text-base sm:text-lg text-center"}
        >
          {"Loading your profile..."}
        </motion.p>
      </div>
    );
  if (!a) return <Navigate to={"/"} replace={true} />;
  const we = (re) => {
      let k = 0;
      for (let Q = 0; Q < re.length; Q++) k = re.charCodeAt(Q) + ((k << 5) - k);
      return `hsl(${k % 360}, 70%, 60%)`;
    },
    L = async () => {
      try {
        (c(true), await i());
      } catch (re) {
        (console.error("Failed to log out", re), c(false));
      }
    };
  return (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Navbar />
      <section
        className={
          "bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 bg-slate-900 pt-10 relative overflow-hidden"
        }
      >
        <div className={"absolute inset-0 bg-black/10"} />
        <div className={"absolute inset-0"}>
          <div
            className={
              "absolute top-0 left-1/4 w-48 h-48 sm:w-72 sm:h-72 bg-white/5 rounded-full blur-3xl"
            }
          />
          <div
            className={
              "absolute bottom-0 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-white/5 rounded-full blur-3xl"
            }
          />
        </div>
        <div className={"relative pt-16 sm:pt-20 pb-24 sm:pb-32"}>
          <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8"}>
            <motion.div
              className={"text-center"}
              initial={"hidden"}
              animate={"visible"}
              variants={de}
            >
              <h1 className={"text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4"}>
                {"My Profile"}
              </h1>
              <p className={"text-indigo-100 text-base sm:text-lg lg:text-xl max-w-2xl mx-auto"}>
                {"Manage your account settings, view your purchases, and update your preferences"}
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      {R && (
        <div className={"fixed top-4 right-4 z-50"}>
          <motion.div
            initial={{
              opacity: 0,
              x: 100,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            exit={{
              opacity: 0,
              x: 100,
            }}
            className={`px-6 py-3 rounded-lg shadow-lg ${R.includes("successfully") ? "bg-green-500 text-white" : "bg-red-500 text-white"}`}
          >
            {R}
          </motion.div>
        </div>
      )}
      <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8 -mt-16 sm:-mt-20 pb-12 sm:pb-16"}>
        <motion.div className={"w-full"} initial={"hidden"} animate={"visible"} variants={Me}>
          <div className={"grid grid-cols-1 lg:grid-cols-4 gap-6 sm:gap-8"}>
            <motion.div
              className={
                "lg:col-span-1 bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-slate-100"
              }
              variants={Ce}
            >
              <div
                className={
                  "bg-slate-800 bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 h-24 sm:h-30 relative"
                }
              >
                <div className={"absolute inset-0 opacity-20"}>
                  <div
                    className={
                      "absolute w-24 h-24 sm:w-32 sm:h-32 bg-white rounded-full -top-12 sm:-top-16 -left-12 sm:-left-16"
                    }
                  />
                  <div
                    className={
                      "absolute w-16 h-16 sm:w-24 sm:h-24 bg-white rounded-full top-6 sm:top-8 right-6 sm:right-8"
                    }
                  />
                </div>
              </div>
              <div className={"px-4 sm:px-6 pb-6 sm:pb-8 relative"}>
                <div className={"flex justify-center -mt-8 sm:-mt-10 lg:-mt-12"}>
                  {ne.profilePicture ? (
                    <img
                      src={ne.profilePicture}
                      alt={"Profile"}
                      className={
                        "h-12 w-12 sm:h-16 sm:w-16 lg:h-20 lg:w-20 rounded-full object-cover border-4 border-white shadow-xl"
                      }
                    />
                  ) : (
                    <div
                      className={
                        "h-12 w-12 sm:h-16 sm:w-16 lg:h-20 lg:w-20 rounded-full flex items-center justify-center text-white text-xl sm:text-2xl lg:text-3xl font-bold uppercase border-4 border-white shadow-xl"
                      }
                      style={{
                        backgroundColor: we(ne.name || ne.email),
                      }}
                    >
                      {(
                        ((X = ne.name) == null ? undefined : X.charAt(0)) ||
                        ((se = ne.email) == null ? undefined : se.charAt(0)) ||
                        "?"
                      ).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className={"mt-4 text-center"}>
                  <h2 className={"text-xl sm:text-2xl font-bold text-slate-800 mb-2"}>
                    {ne.name || "Your Name"}
                  </h2>
                  <div className={"flex items-center justify-center text-slate-600 mb-3 sm:mb-4"}>
                    <MailIcon className={"w-3 h-3 sm:w-4 sm:h-4 mr-2"} />
                    <p className={"text-xs sm:text-sm break-all"}>{ne.email}</p>
                  </div>
                  <div className={"flex justify-center mb-4 sm:mb-6"}>
                    <div
                      className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold flex items-center ${ne.emailVerified ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}
                    >
                      {ne.emailVerified ? (
                        <jsxRuntime.Fragment>
                          <CircleCheckBigIcon className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2"} />
                          {"Verified Account"}
                        </jsxRuntime.Fragment>
                      ) : (
                        <jsxRuntime.Fragment>
                          <CircleAlertIcon className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2"} />
                          {"Pending Verification"}
                        </jsxRuntime.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div className={"lg:col-span-3 space-y-6 sm:space-y-8 z-10"} variants={Me}>
              <motion.div
                className={
                  "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-6 sm:p-8 border border-slate-100"
                }
                variants={de}
              >
                <h3
                  className={
                    "text-xl sm:text-2xl font-bold text-slate-800 mb-6 sm:mb-8 flex items-center"
                  }
                >
                  <div
                    className={
                      "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                    }
                  >
                    <UserIcon className={"w-3 h-3 sm:w-4 sm:h-4 text-white"} />
                  </div>
                  {"Account Information"}
                </h3>
                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6"}>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-indigo-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <label className={"block text-xs sm:text-sm font-semibold text-slate-500 mb-2"}>
                      {"Full Name"}
                    </label>
                    <p className={"text-slate-800 font-bold text-lg sm:text-xl break-words"}>
                      {ne.name || "Not set"}
                    </p>
                  </div>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-purple-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <label className={"block text-xs sm:text-sm font-semibold text-slate-500 mb-2"}>
                      {"Email Address"}
                    </label>
                    <p className={"text-slate-800 font-bold text-lg sm:text-xl break-all"}>
                      {ne.email}
                    </p>
                  </div>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-cyan-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <div className={"flex items-center justify-between mb-2"}>
                      <label className={"text-xs sm:text-sm font-semibold text-slate-500"}>
                        {"Phone Number"}
                      </label>
                      {!b && (
                        <button
                          onClick={() => y(true)}
                          className={
                            "p-1 hover:bg-cyan-100 rounded-full transition-colors duration-200"
                          }
                        >
                          <SquarePenIcon className={"w-3 h-3 sm:w-4 sm:h-4 text-cyan-600"} />
                        </button>
                      )}
                    </div>
                    {b ? (
                      <div className={"space-y-3"}>
                        <input
                          type={"tel"}
                          value={T}
                          charAt={10}
                          onChange={(re) => {
                            const k = re.target.value;
                            /^\d{0,10}$/.test(k) && C(k);
                          }}
                          className={
                            "w-full px-3 py-2 border border-cyan-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-slate-800"
                          }
                          placeholder={"Enter phone number"}
                        />
                        <div className={"flex space-x-2"}>
                          <button
                            onClick={W}
                            disabled={M}
                            className={
                              "flex items-center px-3 py-1.5 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 disabled:opacity-50 text-sm"
                            }
                          >
                            {M ? (
                              <div
                                className={
                                  "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-1"
                                }
                              />
                            ) : (
                              <SaveIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {"Save"}
                          </button>
                          <button
                            onClick={G}
                            className={
                              "flex items-center px-3 py-1.5 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm"
                            }
                          >
                            <XIcon className={"w-3 h-3 mr-1"} />
                            {"Cancel"}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className={"flex items-center"}>
                        <PhoneIcon className={"w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 text-cyan-600"} />
                        <p className={"text-slate-800 font-bold text-lg sm:text-xl"}>
                          {ne.phone || "Not set"}
                        </p>
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-orange-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <div className={"flex items-center justify-between mb-2"}>
                      <label className={"text-xs sm:text-sm font-semibold text-slate-500"}>
                        {"Address"}
                      </label>
                      {!w && (
                        <button
                          onClick={() => N(true)}
                          className={
                            "p-1 hover:bg-orange-100 rounded-full transition-colors duration-200"
                          }
                        >
                          <SquarePenIcon className={"w-3 h-3 sm:w-4 sm:h-4 text-orange-600"} />
                        </button>
                      )}
                    </div>
                    {w ? (
                      <div className={"space-y-3"}>
                        <textarea
                          value={A}
                          onChange={(re) => O(re.target.value)}
                          rows={3}
                          className={
                            "w-full px-3 py-2 border border-orange-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-slate-800 resize-none"
                          }
                          placeholder={"Enter your address"}
                        />
                        <div className={"flex space-x-2"}>
                          <button
                            onClick={B}
                            disabled={M}
                            className={
                              "flex items-center px-3 py-1.5 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 text-sm"
                            }
                          >
                            {M ? (
                              <div
                                className={
                                  "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-1"
                                }
                              />
                            ) : (
                              <SaveIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {"Save"}
                          </button>
                          <button
                            onClick={te}
                            className={
                              "flex items-center px-3 py-1.5 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm"
                            }
                          >
                            <XIcon className={"w-3 h-3 mr-1"} />
                            {"Cancel"}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className={"flex items-start"}>
                        <MapPinIcon
                          className={
                            "w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 text-orange-600 mt-1 flex-shrink-0"
                          }
                        />
                        <p className={"text-slate-800 font-bold text-lg sm:text-xl break-words"}>
                          {ne.address || "Not set"}
                        </p>
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-green-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <label className={"block text-xs sm:text-sm font-semibold text-slate-500 mb-2"}>
                      {"Member Since"}
                    </label>
                    <div className={"flex items-center"}>
                      <CalendarIcon
                        className={"w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 text-green-600"}
                      />
                      <p className={"text-slate-800 font-bold text-base sm:text-lg"}>
                        {new Date(ne.createdAt).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      "bg-gradient-to-br from-slate-50 to-blue-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-slate-100"
                    }
                  >
                    <label className={"block text-xs sm:text-sm font-semibold text-slate-500 mb-2"}>
                      {"Last Updated"}
                    </label>
                    <div className={"flex items-center"}>
                      <ClockIcon className={"w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 text-blue-600"} />
                      <p className={"text-slate-800 font-bold text-base sm:text-lg"}>
                        {new Date(ne.updatedAt).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
              <div className={"grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8"}>
                <motion.div
                  className={
                    "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-6 sm:p-8 border border-slate-100"
                  }
                  variants={de}
                >
                  <h3
                    className={
                      "text-xl sm:text-2xl font-bold text-slate-800 mb-6 sm:mb-8 flex items-center"
                    }
                  >
                    <div
                      className={
                        "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                      }
                    >
                      <ActivityIcon className={"w-3 h-3 sm:w-4 sm:h-4 text-white"} />
                    </div>
                    {"Quick Actions"}
                  </h3>
                  <div className={"space-y-3 sm:space-y-4"}>
                    <Link
                      to={"/my"}
                      className={
                        "flex items-center p-3 sm:p-4 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-purple-50 rounded-xl sm:rounded-2xl transition-all duration-300 group border border-transparent hover:border-indigo-200"
                      }
                    >
                      <div
                        className={
                          "w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center mr-3 sm:mr-4 group-hover:shadow-lg transition-all duration-300"
                        }
                      >
                        <ShoppingBagIcon
                          className={"w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white"}
                        />
                      </div>
                      <div className={"flex-1 min-w-0"}>
                        <p className={"font-bold text-slate-800 text-base sm:text-lg"}>
                          {"My Purchases"}
                        </p>
                        <p className={"text-xs sm:text-sm text-slate-500"}>
                          {"View and manage your projects"}
                        </p>
                      </div>
                      <ArrowRightIcon
                        className={
                          "w-4 h-4 sm:w-5 sm:h-5 text-slate-400 group-hover:text-indigo-500 group-hover:translate-x-1 transition-all duration-300 flex-shrink-0"
                        }
                      />
                    </Link>
                    <button
                      onClick={L}
                      disabled={l}
                      className={
                        "w-full flex items-center p-3 sm:p-4 hover:bg-gradient-to-r hover:from-red-50 hover:to-pink-50 rounded-xl sm:rounded-2xl transition-all duration-300 group border border-transparent hover:border-red-200"
                      }
                    >
                      <div
                        className={
                          "w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-red-500 to-pink-500 flex items-center justify-center mr-3 sm:mr-4 group-hover:shadow-lg transition-all duration-300"
                        }
                      >
                        <LogOutIcon className={"w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white"} />
                      </div>
                      <div className={"text-left flex-1 min-w-0"}>
                        <p className={"font-bold text-slate-800 text-base sm:text-lg"}>
                          {"Sign Out"}
                        </p>
                        <p className={"text-xs sm:text-sm text-slate-500"}>
                          {"Securely log out of your account"}
                        </p>
                      </div>
                      {l ? (
                        <div
                          className={
                            "w-5 h-5 sm:w-6 sm:h-6 border-2 border-red-600 border-t-transparent rounded-full animate-spin flex-shrink-0"
                          }
                        />
                      ) : (
                        <ArrowRightIcon
                          className={
                            "w-4 h-4 sm:w-5 sm:h-5 text-slate-400 group-hover:text-red-500 group-hover:translate-x-1 transition-all duration-300 flex-shrink-0"
                          }
                        />
                      )}
                    </button>
                  </div>
                </motion.div>
                <motion.div
                  className={
                    "bg-white rounded-2xl sm:rounded-3xl shadow-xl p-6 sm:p-8 border border-slate-100"
                  }
                  variants={de}
                >
                  <h3
                    className={
                      "text-xl sm:text-2xl font-bold text-slate-800 mb-6 sm:mb-8 flex items-center"
                    }
                  >
                    <div
                      className={
                        "w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-green-500 to-blue-500 rounded-lg flex items-center justify-center mr-2 sm:mr-3"
                      }
                    >
                      <ShieldIcon className={"w-3 h-3 sm:w-4 sm:h-4 text-white"} />
                    </div>
                    {"Security Status"}
                  </h3>
                  <div className={"space-y-4 sm:space-y-6"}>
                    <div>
                      <label
                        className={
                          "block text-xs sm:text-sm font-semibold text-slate-500 mb-3 sm:mb-4"
                        }
                      >
                        {"Email Verification Status"}
                      </label>
                      <div
                        className={`p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 ${a.emailVerified ? "bg-gradient-to-r from-green-50 to-emerald-50 border-green-200" : "bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200"}`}
                      >
                        {a.emailVerified ? (
                          <div className={"flex items-start sm:items-center"}>
                            <div
                              className={
                                "w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-green-100 flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0"
                              }
                            >
                              <CircleCheckBigIcon
                                className={"w-5 h-5 sm:w-6 sm:h-6 text-green-600"}
                              />
                            </div>
                            <div className={"min-w-0"}>
                              <p className={"text-green-700 font-bold text-base sm:text-lg"}>
                                {"Account Verified"}
                              </p>
                              <p className={"text-xs sm:text-sm text-green-600"}>
                                {"Your email address has been successfully verified"}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div className={"flex items-start sm:items-center"}>
                            <div
                              className={
                                "w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-amber-100 flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0"
                              }
                            >
                              <CircleAlertIcon className={"w-5 h-5 sm:w-6 sm:h-6 text-amber-600"} />
                            </div>
                            <div className={"min-w-0"}>
                              <p className={"text-amber-700 font-bold text-base sm:text-lg"}>
                                {"Verification Pending"}
                              </p>
                              <p className={"text-xs sm:text-sm text-amber-600"}>
                                {"Please check your email and verify your account"}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
export { ProfilePage };
